const focusElement = (selector = '.denhaag-select') => document.querySelectorAll( selector )?.forEach( select => {
  let hadKeyboardEvent = true;

  let cssSelector = selector?.replace( '.', '' );

  /**
   * Detect keyboard usage.
   * @return {boolean}
   */
  const handleKeyDown = () => hadKeyboardEvent = true;

  /**
   * Detect mouse usage.
   * @return {boolean}
   */
  const handlePointerDown = () => hadKeyboardEvent = false;

  select?.addEventListener( 'keydown', handleKeyDown );
  select?.addEventListener( 'pointerdown', handlePointerDown );

  select?.addEventListener( 'focusin', () => {
    if (hadKeyboardEvent) {
      select?.classList.add( `${cssSelector}--focus-visible` );
    }
  } );

  select?.addEventListener( 'focusout', () => select.classList.remove( `${cssSelector}--focus-visible` ));
} );

export default focusElement;
